webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(166);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _settings = __webpack_require__(41);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	__webpack_require__(157);
	
	__webpack_require__(154);
	
	__webpack_require__(70);
	
	var _router = __webpack_require__(63);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _store = __webpack_require__(25);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vueResource = __webpack_require__(191);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vuexRouterSync = __webpack_require__(193);
	
	__webpack_require__(60);
	
	__webpack_require__(61);
	
	__webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var isProduction = ("production") === 'production';
	
	_vue2.default.http.options.root = isProduction ? _settings2.default.production.API_URL : _settings2.default.API.url + ':' + _settings2.default.API.port;
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default);
	
	new _vue2.default({
	  el: '#app',
	  router: _router2.default,
	  store: _store2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.attributify = attributify;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function attributify(el) {
	  var attr = '';
	  if (el.constructor === Object) {
	    attr = (0, _keys2.default)(el).map(function (key) {
	      return el[key];
	    }).join(' ');
	  }
	  return attr;
	}

/***/ },
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(194);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _lodash = __webpack_require__(156);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _settings = __webpack_require__(41);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  lang: _settings2.default.app.lang,
	  tweets: [],
	  max_id: '',
	  hashtag: null,
	  gradients: [],
	  showPreloader: false,
	  showEndMessage: false
	};
	
	var mutations = {
	  ADD_TWEET: function ADD_TWEET(state, tweet) {
	    state.tweets.push(tweet);
	  },
	  REMOVE_FIRST_TWEET: function REMOVE_FIRST_TWEET(state) {
	    state.tweets.shift();
	  },
	  SET_HASHTAG: function SET_HASHTAG(state, hashtag) {
	    state.hashtag = hashtag;
	  },
	  FILTER_UNIQ_TWEETS: function FILTER_UNIQ_TWEETS(state) {
	    state.tweets = _lodash2.default.uniqBy(state.tweets, 'id');
	  },
	  SORT_TWEETS_BY_DATE: function SORT_TWEETS_BY_DATE(state) {
	    state.tweets = _lodash2.default.sortBy(state.tweets, function (tweet) {
	      return new Date(tweet.created_at);
	    });
	  },
	  ADD_GRANIM_GRADIENT: function ADD_GRANIM_GRADIENT(state, gradient) {
	    state.gradients.push(gradient);
	  },
	  SET_TWEETS_MAX_ID: function SET_TWEETS_MAX_ID(state, maxId) {
	    state.max_id = maxId;
	  },
	  SHOW_END_MESSAGE: function SHOW_END_MESSAGE(state, show) {
	    state.showEndMessage = show;
	  },
	  RESET_TWEETS: function RESET_TWEETS(state) {
	    state.tweets = [];
	  },
	  SHOW_PRELOADER: function SHOW_PRELOADER(state, show) {
	    state.showPreloader = show;
	  }
	};
	
	var actions = {
	  addTweet: function addTweet(_ref, tweet) {
	    var commit = _ref.commit;
	
	    commit('ADD_TWEET', tweet);
	  },
	  removeFirstTweet: function removeFirstTweet(_ref2) {
	    var commit = _ref2.commit;
	
	    commit('REMOVE_FIRST_TWEET');
	  },
	  setHashtag: function setHashtag(_ref3, hashtag) {
	    var commit = _ref3.commit;
	
	    commit('SET_HASHTAG', hashtag);
	  },
	  filterUniqTweets: function filterUniqTweets(_ref4) {
	    var commit = _ref4.commit;
	
	    commit('FILTER_UNIQ_TWEETS');
	  },
	  sortTweetsByDate: function sortTweetsByDate(_ref5) {
	    var commit = _ref5.commit;
	
	    commit('SORT_TWEETS_BY_DATE');
	  },
	  updateTweets: function updateTweets(_ref6) {
	    var commit = _ref6.commit;
	
	    commit('FILTER_UNIQ_TWEETS');
	    commit('SORT_TWEETS_BY_DATE');
	  },
	  addGranimGradient: function addGranimGradient(_ref7, gradient) {
	    var commit = _ref7.commit;
	
	    commit('ADD_GRANIM_GRADIENT', gradient);
	  },
	  setTweetsMaxId: function setTweetsMaxId(_ref8, maxId) {
	    var commit = _ref8.commit;
	
	    commit('SET_TWEETS_MAX_ID', maxId);
	  },
	  resetTweets: function resetTweets(_ref9) {
	    var commit = _ref9.commit;
	
	    commit('RESET_TWEETS');
	  },
	  showEndMessage: function showEndMessage(_ref10, show) {
	    var commit = _ref10.commit;
	
	    commit('SHOW_END_MESSAGE', show);
	  },
	  resetAfterExperiment: function resetAfterExperiment(_ref11) {
	    var commit = _ref11.commit;
	
	    commit('SET_HASHTAG', null);
	    commit('RESET_TWEETS'), commit('SET_TWEETS_MAX_ID', '');
	  },
	  showPreloader: function showPreloader(_ref12, show) {
	    var commit = _ref12.commit;
	
	    commit('SHOW_PRELOADER', show);
	  }
	};
	
	var store = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations,
	  actions: actions
	});
	
	exports.default = store;

/***/ },
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = __webpack_require__(88);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(84);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var files = [];
	try {
	  files.push(__webpack_require__(155));
	} catch (e) {
	  console.warn('Unable to load settings', e);
	}
	
	function override(target, object) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(object)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var key = _step.value;
	
	      if (target[key] && (0, _typeof3.default)(object[key]) === 'object') {
	        override(target[key], object[key]);
	      } else {
	        target[key] = object[key];
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	
	var settings = {};
	var _iteratorNormalCompletion2 = true;
	var _didIteratorError2 = false;
	var _iteratorError2 = undefined;
	
	try {
	  for (var _iterator2 = (0, _getIterator3.default)(files), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	    var f = _step2.value;
	
	    override(settings, f);
	  }
	} catch (err) {
	  _didIteratorError2 = true;
	  _iteratorError2 = err;
	} finally {
	  try {
	    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	      _iterator2.return();
	    }
	  } finally {
	    if (_didIteratorError2) {
	      throw _iteratorError2;
	    }
	  }
	}
	
	if (({"NODE_ENV":"production"})['NODE_ENV'] === 'development') {
	  console.log(settings);
	}
	
	module.exports = settings;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(18);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TWEET_SEPARATOR = 10;
	var TWEET_SIZE = {
	  width: 5,
	  height: 5,
	  canvasWidth: 512,
	  canvasHeight: 512
	};
	var TWEET_ROTATION = { x: 0, y: 30, z: 0 };
	
	var SPEED = 60;
	var PATH_AMOUNT_PER_CYCLE = 100;
	var PATH_AMPLITUDE = {
	  x: { min: 1, max: 3 },
	  y: { min: 1, max: 2 }
	};
	var PATH_FREQUENCY = {
	  x: { min: 3, max: 5 },
	  y: { min: 3, max: 5 }
	};
	
	var SimulationParams = function () {
	  function SimulationParams() {
	    (0, _classCallCheck3.default)(this, SimulationParams);
	  }
	
	  (0, _createClass3.default)(SimulationParams, null, [{
	    key: "tweetSize",
	    get: function get() {
	      return TWEET_SIZE;
	    }
	  }, {
	    key: "tweetRotation",
	    get: function get() {
	      return TWEET_ROTATION;
	    }
	  }, {
	    key: "tweetSeparator",
	    get: function get() {
	      return TWEET_SEPARATOR;
	    }
	  }, {
	    key: "speed",
	    get: function get() {
	      return SPEED;
	    }
	  }, {
	    key: "pathAmountPerCycle",
	    get: function get() {
	      return PATH_AMOUNT_PER_CYCLE;
	    }
	  }, {
	    key: "pathAmplitude",
	    get: function get() {
	      return PATH_AMPLITUDE;
	    }
	  }, {
	    key: "pathFrequency",
	    get: function get() {
	      return PATH_FREQUENCY;
	    }
	  }]);
	  return SimulationParams;
	}();
	
	exports.default = SimulationParams;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.getTweetsFromAPI = getTweetsFromAPI;
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _index = __webpack_require__(25);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function tweetFromStatus(status) {
	  return {
	    id: status.id_str,
	    author: {
	      image_url: status.user.profile_image_url,
	      name: status.user.name,
	      screen_name: status.user.screen_name
	    },
	    created_at: status.created_at,
	    content: status.text
	  };
	}
	
	function getTweetsFromAPI() {
	  return new _promise2.default(function (resolve, reject) {
	    var hashtag = _index2.default.state.hashtag;
	    var max_id = _index2.default.state.max_id || '';
	    _vue2.default.http.get('search/' + hashtag + '?max_id=' + max_id).then(function (response) {
	      var min = max_id === '' ? 5 : 1;
	      if (response.data.statuses.length >= min) {
	        _index2.default.dispatch('setTweetsMaxId', response.data['search_metadata']['max_id_str']);
	        response.data.statuses.forEach(function (status) {
	          var tweet = tweetFromStatus(status);
	          _index2.default.dispatch('addTweet', tweet);
	        });
	        resolve();
	      } else {
	        reject({ error: -1 });
	      }
	    }, function (response) {
	      reject(response);
	    });
	  });
	}

/***/ },
/* 44 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isMobile = isMobile;
	function isMobile() {
	  var isMobile = false;
	
	  (function (a) {
	    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) isMobile = true;
	  })(navigator.userAgent || navigator.vendor || window.opera);
	
	  return isMobile;
	}

/***/ },
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(131)
	
	/* script */
	__vue_exports__ = __webpack_require__(76)
	
	/* template */
	var __vue_template__ = __webpack_require__(180)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-40fe0bdf"
	
	module.exports = __vue_exports__


/***/ },
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(192);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Home = __webpack_require__(176);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Hashtag = __webpack_require__(175);
	
	var _Hashtag2 = _interopRequireDefault(_Hashtag);
	
	var _Timeline = __webpack_require__(177);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	exports.default = new _vueRouter2.default({
	  mode: 'hash',
	  routes: [{
	    name: 'home',
	    path: '/',
	    component: _Home2.default
	  }, {
	    name: 'hashtag',
	    path: '/hashtag',
	    component: _Hashtag2.default
	  }, {
	    name: 'timeline',
	    path: '/timeline',
	    component: _Timeline2.default
	  }, {
	    path: '*',
	    redirect: '/'
	  }]
	});

/***/ },
/* 64 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CanvasTextWrapper = CanvasTextWrapper;
	exports.getLines = getLines;
	function CanvasTextWrapper(canvas, lines, style) {
	
	  var width = canvas.width * 2;
	  var height = canvas.height * 2;
	  var ctx = canvas.getContext('2d');
	  var fontSize = style.fontSize || 30;
	  var lineheight = 1 * fontSize;
	
	  ctx.font = 'normal ' + fontSize + 'px Source Sans Pro, sans-serif';
	  ctx.textAlign = 'center';
	  ctx.textBaseline = 'middle';
	  ctx.fillStyle = style.color || '#000000';
	
	  var maxTextWidth = width / 3 - fontSize * 1.5;
	
	  lines.map(function (line, i) {
	    return ctx.fillText(line, width / 4, height / 3.5 + lineheight * (i + 1) - lines.length * 5, maxTextWidth);
	  });
	}
	
	function getLines(ctx, text, canvasWidth, fontSize) {
	  var maxTextWidth = canvasWidth / 3 - fontSize * 1.5;
	  var words = text.split(' ');
	  var lines = words.reduce(function (acc, word) {
	    var lastLineIndex = acc.length > 0 ? acc.length - 1 : 0;
	    var lastLine = acc[lastLineIndex];
	    var line = [lastLine, word].join(' ').trim();
	    var metrics = ctx.measureText(line);
	    var lineWidth = metrics.width;
	
	    if (lineWidth > maxTextWidth) {
	      acc[lastLineIndex + 1] = word;
	    } else {
	      acc[lastLineIndex] = line;
	    }
	
	    return acc;
	  }, []);
	
	  return lines;
	}

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(18);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var instance = null;
	
	var PathCalculator = function () {
	  function PathCalculator() {
	    (0, _classCallCheck3.default)(this, PathCalculator);
	
	    if (!instance) {
	      instance = this;
	      this.amplitude = {};
	      this.frequency = {};
	    }
	
	    return instance;
	  }
	
	  (0, _createClass3.default)(PathCalculator, null, [{
	    key: 'setAmplitude',
	    value: function setAmplitude(x, y) {
	      instance.amplitude.x = x;
	      instance.amplitude.y = y;
	    }
	  }, {
	    key: 'setFrequency',
	    value: function setFrequency(x, y) {
	      instance.frequency.x = x;
	      instance.frequency.y = y;
	    }
	  }, {
	    key: 'at',
	    value: function at(offset) {
	      var x = instance.amplitude.x * Math.sin(instance.frequency.x * offset * 3.1415926535 / 180);
	      var y = instance.amplitude.y * Math.sin(instance.frequency.y * offset * 3.1415926535 / 180);
	      var z = -offset;
	
	      return { x: x, y: y, z: z };
	    }
	  }, {
	    key: 'after',
	    value: function after(offset, position) {
	      var x = instance.amplitude.x * Math.sin(instance.frequency.x * offset * 3.1415926535 / 180) + (position === 'left' ? 3 : -3);
	      var y = instance.amplitude.y * Math.sin(instance.frequency.y * offset * 3.1415926535 / 180);
	      var z = -offset;
	
	      return { x: x, y: y, z: z };
	    }
	  }, {
	    key: 'objectAfter',
	    value: function objectAfter(offset) {
	      var x = instance.amplitude.x * Math.sin(instance.frequency.x * offset * 3.1415926535 / 180);
	      var y = instance.amplitude.y * Math.sin(instance.frequency.y * offset * 3.1415926535 / 180);
	      var z = -offset;
	
	      return { x: x, y: y, z: z };
	    }
	  }]);
	  return PathCalculator;
	}();
	
	new PathCalculator();
	
	exports.default = PathCalculator;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(18);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _CanvasTextWrapper = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textStyle = {
	  fontSize: 25,
	  color: '#021941'
	};
	
	var imageStyle = {
	  imageSize: 50,
	  imageMargin: 30
	};
	
	var TweetDrawer = function () {
	  function TweetDrawer(tweet, canvas) {
	    (0, _classCallCheck3.default)(this, TweetDrawer);
	
	    this.tweet = tweet;
	    this.canvas = canvas;
	    this.ctx = canvas.getContext('2d');
	    this.color = '#FF0000';
	    this.lines = (0, _CanvasTextWrapper.getLines)(this.ctx, this.tweet.content, this.canvas.width, textStyle.fontSize);
	    this.filterOpacity = 0.7;
	  }
	
	  (0, _createClass3.default)(TweetDrawer, [{
	    key: 'drawBackground',
	    value: function drawBackground() {
	      var grd = this.ctx.createLinearGradient(150.000, 0.000, 150.000, 300.000);
	
	      grd.addColorStop(0.000, 'rgba(161, 196, 253, 1.000)');
	      grd.addColorStop(1.000, 'rgba(194, 233, 251, 1.000)');
	
	      this.ctx.fillStyle = grd;
	      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
	    }
	  }, {
	    key: 'getImageLightness',
	    value: function getImageLightness() {
	      var imageData = this.ctx.getImageData(this.canvas.width / 2 - imageStyle.imageSize, 150 - (this.lines.length + 1) * 5 - imageStyle.imageSize, 2 * imageStyle.imageSize, 2 * imageStyle.imageSize);
	      var data = imageData.data;
	      var color = { r: 0, g: 0, b: 0 };
	      var avg = void 0;
	      var colorSum = 0;
	
	      for (var x = 0, len = data.length; x < len; x += 4) {
	        color.r = data[x];
	        color.g = data[x + 1];
	        color.b = data[x + 2];
	
	        avg = Math.floor((color.r + color.g + color.b) / 3);
	        colorSum += avg;
	      }
	
	      var brightness = Math.floor(colorSum / (2 * imageStyle.imageSize * (2 * imageStyle.imageSize)));
	
	      if (brightness <= 100) {
	        this.filterOpacity = 0.4;
	      } else if (brightness <= 140) {
	        this.filterOpacity = 0.6;
	      } else {
	        this.filterOpacity = 0.8;
	      }
	    }
	  }, {
	    key: 'drawContent',
	    value: function drawContent() {
	      (0, _CanvasTextWrapper.CanvasTextWrapper)(this.canvas, this.lines, textStyle);
	    }
	  }, {
	    key: 'drawImage',
	    value: function drawImage() {
	      var _this = this;
	
	      var promise = new _promise2.default(function (resolve, reject) {
	        var img = new Image();
	        img.crossOrigin = 'anonymous';
	        img.onload = function () {
	
	          _this.ctx.save();
	          _this.ctx.beginPath();
	          _this.ctx.arc(_this.canvas.width / 2, 150 - (_this.lines.length + 1) * 5, imageStyle.imageSize, 0, Math.PI * 2, true);
	          _this.ctx.closePath();
	          _this.ctx.clip();
	
	          _this.ctx.filter = 'grayscale(100%)';
	          _this.ctx.drawImage(img, _this.canvas.width / 2 - imageStyle.imageSize, 150 - (_this.lines.length + 1) * 5 - imageStyle.imageSize, 2 * imageStyle.imageSize, 2 * imageStyle.imageSize);
	          _this.ctx.filter = 'grayscale(0%)';
	
	          _this.getImageLightness();
	
	          _this.ctx.beginPath();
	          _this.ctx.arc(_this.canvas.width / 2 - imageStyle.imageSize, 150 - (_this.lines.length + 1) * 5 - imageStyle.imageSize, imageStyle.imageSize, 0, Math.PI * 2, true);
	          _this.ctx.clip();
	          _this.ctx.closePath();
	          _this.ctx.restore();
	
	          _this.ctx.save();
	          _this.ctx.beginPath();
	          _this.ctx.arc(_this.canvas.width / 2, 150 - (_this.lines.length + 1) * 5, 50, 0, 2 * Math.PI);
	          _this.ctx.closePath();
	          _this.ctx.globalAlpha = _this.filterOpacity;
	          _this.ctx.fillStyle = '#112c5b';
	          _this.ctx.fill();
	          _this.ctx.globalAlpha = 1;
	          _this.ctx.strokeStyle = "#021941";
	          _this.ctx.lineWidth = 5;
	          _this.ctx.stroke();
	          _this.ctx.restore();
	
	          resolve();
	        };
	        img.src = _this.tweet.author.image_url;
	      });
	
	      return promise;
	    }
	  }, {
	    key: 'drawUserName',
	    value: function drawUserName() {
	      this.ctx.font = 'bold 30px Source Sans Pro, sans-serif';
	      this.ctx.fillStyle = '#021941';
	      this.ctx.textAlign = 'center';
	      this.ctx.fillText(this.tweet.author.name, this.canvas.width / 2, 150 - (this.lines.length + 1) * 5 + imageStyle.imageSize + 30);
	    }
	  }, {
	    key: 'drawUserScreenName',
	    value: function drawUserScreenName() {
	      this.ctx.font = 'italic 20px Source Sans Pro, sans-serif';
	      this.ctx.fillStyle = '#021941';
	      this.ctx.textAlign = 'center';
	      this.ctx.fillText('@' + this.tweet.author.screen_name, this.canvas.width / 2, 150 - (this.lines.length + 1) * 5 + imageStyle.imageSize + 65);
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var _this2 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        _this2.drawBackground();
	        _this2.drawContent();
	        _this2.drawUserName();
	        _this2.drawUserScreenName();
	        _this2.drawImage().then(function () {
	          resolve(_this2.canvas);
	        });
	      });
	    }
	  }]);
	  return TweetDrawer;
	}();
	
	exports.default = TweetDrawer;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(18);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Random = function () {
	  function Random() {
	    (0, _classCallCheck3.default)(this, Random);
	  }
	
	  (0, _createClass3.default)(Random, null, [{
	    key: "getRandomInt",
	    value: function getRandomInt(min, max) {
	      min = Math.ceil(min);
	      max = Math.floor(max);
	      return Math.floor(Math.random() * (max - min + 1)) + min;
	    }
	  }]);
	  return Random;
	}();
	
	exports.default = Random;

/***/ },
/* 68 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  'hello': 'Hi',
	  'hashtag': 'Insert your hashtag'
	};

/***/ },
/* 69 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  'hello': 'Bonjour',
	  'hashtag': 'Insérez votre hashtag'
	};

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(165);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _store = __webpack_require__(25);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueI18n2.default);
	_vue2.default.config.lang = _store2.default.state.lang;
	
	var locales = {
	  fr: __webpack_require__(69),
	  en: __webpack_require__(68)
	};
	
	(0, _keys2.default)(locales).forEach(function (lang) {
	  _vue2.default.locale(lang, locales[lang]);
	});
	
	_store2.default.subscribe(function (mutation, state) {
	  _vue2.default.config.lang = state.lang;
	});

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GradientCanvas = __webpack_require__(59);
	
	var _GradientCanvas2 = _interopRequireDefault(_GradientCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'App',
	  data: function data() {
	    return {
	      currentRoute: this.$router.currentRoute.name
	    };
	  },
	
	  components: {
	    GradientCanvas: _GradientCanvas2.default
	  },
	  watch: {
	    $route: function $route() {
	      this.currentRoute = this.$route.name;
	    }
	  }
	};

/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Assets',
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {}
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _aframeUtils = __webpack_require__(17);
	
	var _EndMessage = __webpack_require__(169);
	
	var _EndMessage2 = _interopRequireDefault(_EndMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Camera',
	  props: {
	    position: Object,
	    controlsEnabled: Boolean
	  },
	  methods: {
	    attributify: _aframeUtils.attributify
	  },
	  components: {
	    EndMessage: _EndMessage2.default
	  }
	};

/***/ },
/* 74 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'EndMessage',
	  data: function data() {
	    return {
	      message: 'EXPERIMENT OVER'
	    };
	  },
	
	  computed: {
	    showEndMessage: function showEndMessage() {
	      return this.$store.state.showEndMessage;
	    }
	  }
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _aframeUtils = __webpack_require__(17);
	
	exports.default = {
	  replace: true,
	  props: {
	    id: 0,
	    position: Object,
	    rotation: Object
	  },
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {},
	  beforeDestroy: function beforeDestroy() {},
	
	  methods: {
	    attributify: _aframeUtils.attributify
	  }
	};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _granim = __webpack_require__(136);
	
	var _granim2 = _interopRequireDefault(_granim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GradientCanvas',
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	    defaultState: {
	      type: String,
	      required: true
	    }
	  },
	  mounted: function mounted() {
	
	    var granimInstance = new _granim2.default({
	      element: '#' + this.name,
	      direction: 'diagonal',
	      defaultStateName: this.defaultState,
	      opacity: [1, 1],
	      states: {
	        'home-state': {
	          gradients: [['#21C2CC', '#6B4BBA'], ['#229EA6', '#3F28B1']]
	        },
	        'timeline-state': {
	          gradients: [['#021941', '#021432']]
	        }
	      }
	    });
	
	    this.$el.width = 512;
	    this.$el.height = 512;
	
	    this.$store.dispatch('addGranimGradient', { name: this.name, gradient: granimInstance });
	  }
	};

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _aframeUtils = __webpack_require__(17);
	
	exports.default = {
	  name: 'Light',
	  props: {
	    position: Object
	  },
	  methods: {
	    attributify: _aframeUtils.attributify
	  }
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isMobile = __webpack_require__(44);
	
	exports.default = {
	  name: 'Preloader',
	  props: {
	    display: Boolean
	  },
	  data: function data() {
	    return {
	      showPreloaderIcon: false,
	      showPreloaderInfos: false
	    };
	  },
	
	  computed: {
	    mobile: function mobile() {
	      return (0, _isMobile.isMobile)();
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$store.subscribe(function (mutation, state) {
	      if (mutation.type === 'SHOW_PRELOADER') {
	        if (state.showPreloader) {
	          setTimeout(function () {
	            _this.showPreloaderIcon = true;
	          }, 1 * 1000);
	          setTimeout(function () {
	            _this.showPreloaderInfos = true;
	          }, 1.5 * 1000);
	        } else {
	          _this.showPreloaderIcon = false;
	          _this.showPreloaderInfos = false;
	        }
	      }
	    });
	  }
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Camera = __webpack_require__(168);
	
	var _Camera2 = _interopRequireDefault(_Camera);
	
	var _Assets = __webpack_require__(167);
	
	var _Assets2 = _interopRequireDefault(_Assets);
	
	var _Light = __webpack_require__(171);
	
	var _Light2 = _interopRequireDefault(_Light);
	
	var _Tweet = __webpack_require__(174);
	
	var _Tweet2 = _interopRequireDefault(_Tweet);
	
	var _Frame = __webpack_require__(170);
	
	var _Frame2 = _interopRequireDefault(_Frame);
	
	var _params = __webpack_require__(42);
	
	var _params2 = _interopRequireDefault(_params);
	
	var _random = __webpack_require__(67);
	
	var _random2 = _interopRequireDefault(_random);
	
	var _PathCalculator = __webpack_require__(65);
	
	var _PathCalculator2 = _interopRequireDefault(_PathCalculator);
	
	var _api = __webpack_require__(43);
	
	var _isMobile = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cycleFramesInterval = null;
	var cycleTweetsInterval = null;
	var cameraTween = null;
	
	exports.default = {
	  name: 'Renderer',
	  components: {
	    'camera': _Camera2.default,
	    'assets': _Assets2.default,
	    'tweet': _Tweet2.default,
	    'light': _Light2.default,
	    'frame': _Frame2.default
	  },
	  data: function data() {
	    return {
	      controlsEnabled: true,
	      inProgress: true,
	      isVR: false,
	      frameParams: {
	        number: 0,
	        offset: 0,
	        separator: 32,
	        rotation: 0,
	        rotationOffset: 20
	      },
	      framesToRender: [],
	      tweetsToRender: [],
	      isLoaded: false,
	      framesAreReady: false,
	      experimentOngoing: true,
	      camera: {
	        position: { x: 0, y: 0, z: 0 }
	      },
	      paths: [],
	      pathParams: {
	        offset: 0,
	        separator: _params2.default.pathAmountPerCycle / 2
	      },
	      lastPath: { x: 0, y: 0, z: 0 }
	    };
	  },
	  computed: {
	    sceneIsReady: function sceneIsReady() {
	      return this.isLoaded && this.framesAreReady;
	    },
	    hasHashtag: function hasHashtag() {
	      return !!this.$store.state.hashtag;
	    },
	    tweets: function tweets() {
	      return this.$store.state.tweets;
	    },
	
	    visibleTweets: function visibleTweets() {
	      var _this = this;
	
	      return this.tweetsToRender.filter(function (tweet) {
	        return Math.abs(tweet.position.z) > Math.abs(_this.camera.position.z) - 5 && Math.abs(tweet.position.z) < Math.abs(_this.camera.position.z) + 50;
	      });
	    },
	    visibleFrames: function visibleFrames() {
	      var _this2 = this;
	
	      return this.framesToRender.filter(function (frame) {
	        return Math.abs(frame.position.z) > Math.abs(_this2.camera.position.z) - 20 && Math.abs(frame.position.z) < Math.abs(_this2.camera.position.z) + 250;
	      });
	    }
	  },
	  methods: {
	    drawPath: function drawPath() {
	      var tempPaths = [];
	      for (var i = this.pathParams.offset; i < _params2.default.pathAmountPerCycle + this.pathParams.offset; ++i) {
	        tempPaths.push(_PathCalculator2.default.at(i));
	      }
	
	      this.paths = tempPaths;
	      this.pathParams.offset += _params2.default.pathAmountPerCycle;
	    },
	    startSimulation: function startSimulation() {
	      cameraTween = TweenMax.to(this.camera.position, _params2.default.speed, { bezier: this.paths, ease: Linear.easeNone, repeat: 0, onComplete: this.buildSplineAndRun });
	    },
	    buildSplineAndRun: function buildSplineAndRun() {
	      this.drawPath();
	      this.startSimulation();
	    },
	    initFirstFrames: function initFirstFrames() {
	      for (var nb = 0; nb < 10; nb++) {
	        this.cycleFrames();
	      }
	      this.framesAreReady = true;
	      cycleFramesInterval = setInterval(this.cycleFrames, 1000);
	    },
	    cycleFrames: function cycleFrames() {
	      if (this.framesToRender.length < this.tweetsToRender.length + 10) {
	        var frame = {};
	
	        frame.id = this.frameParams.number;
	        frame.position = _PathCalculator2.default.objectAfter(this.frameParams.offset + 10);
	        frame.rotation = { x: 0, y: 45, z: 0 };
	
	        this.frameParams.number += 1;
	        this.frameParams.offset += this.frameParams.separator;
	        this.frameParams.rotation += this.frameParams.rotationOffset;
	
	        this.framesToRender.push(frame);
	      }
	    },
	    cycleTweets: function cycleTweets() {
	      var _this3 = this;
	
	      if (this.tweets.length > 0) {
	        var tweet = this.tweets[0];
	
	        if (this.tweetsToRender.length % 2 == 0) {
	          tweet.position = _PathCalculator2.default.after(this.pathParams.separator - 30, 'left');
	        } else {
	          tweet.position = _PathCalculator2.default.after(this.pathParams.separator - 30, 'right');
	        }
	
	        this.$store.dispatch('removeFirstTweet');
	        this.pathParams.separator += _params2.default.tweetSeparator;
	        this.tweetsToRender.push(tweet);
	
	        if (this.experimentOngoing && this.tweets.length < 5) {
	          (0, _api.getTweetsFromAPI)().then(function () {
	            return _this3.$store.dispatch('updateTweets');
	          }, function () {
	            return _this3.experimentOngoing = false;
	          });
	        }
	      }
	
	      if (this.visibleTweets.length == 0) {
	        this.controlsEnabled = false;
	        document.querySelector('#spot-light').emit('turn-the-light-off');
	        this.$store.dispatch('showEndMessage', true);
	        clearInterval(cycleTweetsInterval);
	        clearInterval(cycleFramesInterval);
	        var redirectToHome = setTimeout(function () {
	          if (_this3.isVR) {
	            _this3.$el.querySelector('a-scene').exitVR();
	          }
	          _this3.$router.push({ path: '/hashtag' });
	        }, 6 * 1000);
	      }
	    },
	    createPauseHandler: function createPauseHandler() {
	      if ((0, _isMobile.isMobile)()) {
	        window.addEventListener('touchstart', this.pauseOrPlayTouchHandler, false);
	        window.addEventListener('touchend', this.pauseOrPlayTouchHandler, false);
	      } else {
	        window.addEventListener('keydown', this.pauseOrPlaySpacebarHandler, false);
	        window.addEventListener('keyup', this.pauseOrPlaySpacebarHandler, false);
	      }
	    },
	    pause: function pause() {
	      cameraTween.timeScale(0.3);
	    },
	    play: function play() {
	      cameraTween.timeScale(1);
	    },
	    pauseOrPlaySpacebarHandler: function pauseOrPlaySpacebarHandler(e) {
	      var onSpaceDown = function onSpaceDown(e, f) {
	        if (e.code == 'Space' && e.type == 'keydown') f();
	      };
	      var onSpaceUp = function onSpaceUp(e, f) {
	        if (e.code == 'Space' && e.type == 'keyup') f();
	      };
	      onSpaceDown(e, this.pause);
	      onSpaceUp(e, this.play);
	    },
	    pauseOrPlayTouchHandler: function pauseOrPlayTouchHandler(e) {
	      var onTouchStart = function onTouchStart(e, f) {
	        if (e.type == 'touchstart') f();
	      };
	      var onTouchEnd = function onTouchEnd(e, f) {
	        if (e.type == 'touchend') f();
	      };
	      onTouchStart(e, this.pause);
	      onTouchEnd(e, this.play);
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.$store.dispatch('showEndMessage', false);
	
	    var freq = _params2.default.pathFrequency;
	    var ampl = _params2.default.pathAmplitude;
	    _PathCalculator2.default.setAmplitude(_random2.default.getRandomInt(ampl.x.min, ampl.x.max), _random2.default.getRandomInt(ampl.y.min, ampl.y.max));
	    _PathCalculator2.default.setFrequency(_random2.default.getRandomInt(freq.x.min, freq.x.max) + Math.random() * 2, _random2.default.getRandomInt(freq.y.min, freq.y.max) + Math.random() * 2);
	
	    this.initFirstFrames();
	
	    var startIfOk = function startIfOk() {
	      if (_this4.hasHashtag) {
	        _this4.isLoaded = true;
	        _this4.buildSplineAndRun();
	        cycleTweetsInterval = setInterval(_this4.cycleTweets, 1000);
	        _this4.createPauseHandler();
	      } else {
	        _this4.$router.push({ path: '/hashtag' });
	      }
	    };
	
	    var scene = this.$el.querySelector('a-scene');
	    if (scene.hasLoaded) {
	      startIfOk();
	    } else {
	      scene.addEventListener('loaded', startIfOk);
	    }
	
	    var events = 'enter-vr exit-vr';
	    events.split(' ').forEach(function (e) {
	      return scene.addEventListener(e, function () {
	        _this4.isVR = scene.is('vr-mode');
	      });
	    }, false);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(cycleTweetsInterval);
	    clearInterval(cycleFramesInterval);
	    if ((0, _isMobile.isMobile)()) {
	      document.removeEventListener('touchstart', this.pauseOrPlayTouchHandler);
	      document.removeEventListener('touchend', this.pauseOrPlayTouchHandler);
	    } else {
	      document.removeEventListener('keyup', this.pauseOrPlaySpacebarHandler);
	      document.removeEventListener('keydown', this.pauseOrPlaySpacebarHandler);
	    }
	    this.$store.dispatch('resetAfterExperiment');
	  }
	};

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TweetDrawer = __webpack_require__(66);
	
	var _TweetDrawer2 = _interopRequireDefault(_TweetDrawer);
	
	var _params = __webpack_require__(42);
	
	var _params2 = _interopRequireDefault(_params);
	
	var _aframeUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  replace: true,
	  props: {
	    position: Object,
	    tweet: Object
	  },
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    tweetParams: function tweetParams() {
	      return _params2.default.tweetSize;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.setTimeout(function () {
	
	      var canvas = document.createElement('canvas');
	      canvas.width = _params2.default.tweetSize.canvasWidth;
	      canvas.height = _params2.default.tweetSize.canvasHeight;
	
	      var tweetDrawer = new _TweetDrawer2.default(_this.tweet, canvas);
	
	      tweetDrawer.draw().then(function (c) {
	        var texture = new THREE.Texture(c);
	        var material = new THREE.MeshBasicMaterial({ map: texture, transparent: true, opacity: 0 });
	        _this.$el.object3D.children[0].material = material;
	        texture.needsUpdate = true;
	
	        var fadeIn = 0;
	        var fadeTexture = setInterval(function () {
	          if (fadeIn >= 1.0) {
	            clearInterval(fadeTexture);
	          }
	          fadeIn += 0.1;
	          _this.$el.object3D.children[0].material.opacity = fadeIn;
	        }, 100);
	      });
	    }, 100);
	  },
	  beforeDestroy: function beforeDestroy() {},
	
	  methods: {
	    attributify: _aframeUtils.attributify
	  }
	};

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _Preloader = __webpack_require__(172);
	
	var _Preloader2 = _interopRequireDefault(_Preloader);
	
	var _api = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Hashtag',
	  data: function data() {
	    return {
	      requestError: {
	        message: '',
	        show: false
	      },
	      waitingResponseFromAPI: false,
	      userHashtag: '',
	      isLoading: false,
	      inputMaxLength: 40
	    };
	  },
	
	  components: {
	    Preloader: _Preloader2.default
	  },
	  computed: {
	    isHashtag: function isHashtag() {
	      var regex = /^\w{1,100}$/;
	      return regex.test(this.userHashtag);
	    },
	    gradientCanvas: function gradientCanvas() {
	      return this.$store.state.gradients.find(function (item) {
	        return item.name === 'canvas-interactive';
	      });
	    },
	    inputWidthStyle: function inputWidthStyle() {
	      return 'width: ' + (this.userHashtag.length + 2) * 0.8 + 'rem;';
	    }
	  },
	  methods: {
	    start: function start() {
	      var _this = this;
	
	      this.waitingResponseFromAPI = true;
	
	      this.$store.dispatch('setHashtag', this.userHashtag);
	      this.userHashtag = '';
	
	      (0, _api.getTweetsFromAPI)().then(function () {
	        _this.isLoading = true;
	        _this.gradientCanvas.gradient.changeState('timeline-state');
	        _this.startLoader().then(function () {
	          _this.$store.dispatch('sortTweetsByDate');
	          setTimeout(function () {
	            _this.goToTimeline();
	          }, 3 * 1000);
	        });
	      }, function (response) {
	        if (response.error == -1) {
	          _this.requestError.message = 'Your hashtag seems to be not very famous';
	        } else {
	          _this.requestError.message = 'Problem when connecting to the twitter API. The Twitter API throttling being pretty heavy, you might have to try again later. Sorry!';
	        }
	
	        setTimeout(function () {
	          _this.requestError.show = true;
	        }, 1 * 1000);
	        setTimeout(function () {
	          _this.requestError.show = false;
	        }, 3 * 1000);
	
	        setTimeout(function () {
	          _this.waitingResponseFromAPI = false;
	        }, 4 * 1000);
	      });
	    },
	    startLoader: function startLoader() {
	      var _this2 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        _this2.$store.dispatch('showPreloader', true);
	        setTimeout(function () {
	          resolve();
	        }, 3 * 1000);
	      });
	    },
	    goToTimeline: function goToTimeline() {
	      var _this3 = this;
	
	      this.$store.dispatch('showPreloader', false);
	      setTimeout(function () {
	        _this3.isLoading = false;
	        _this3.$router.push({ path: '/timeline' });
	      }, 1 * 1000);
	    },
	    focusToInput: function focusToInput() {
	      this.$el.querySelector('#hashtaginput').focus();
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    if (this.gradientCanvas) {
	      this.gradientCanvas.gradient.changeState('home-state');
	    }
	
	    this.$el.querySelector('#hashtaginput').addEventListener('keypress', function (ev) {
	      var key = ev.which || ev.keyCode;
	      if (key === 13 && _this4.isHashtag) {
	        _this4.start();
	      }
	    });
	
	    if (window.innerWidth < 640) {
	      this.inputMaxLength = 20;
	    } else {
	      this.inputMaxLength = 40;
	    }
	
	    window.addEventListener('resize', function () {
	      if (window.innerWidth < 640) {
	        _this4.inputMaxLength = 20;
	      } else {
	        _this4.inputMaxLength = 40;
	      }
	    });
	
	    this.focusToInput();
	  }
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GradientCanvas = __webpack_require__(59);
	
	var _GradientCanvas2 = _interopRequireDefault(_GradientCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Home',
	  data: function data() {
	    return {
	      showLogo: false
	    };
	  },
	
	  components: {
	    GradientCanvas: _GradientCanvas2.default
	  },
	  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
	    this.showLogo = false;
	    setTimeout(function () {
	      next();
	    }, 1 * 1000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.showLogo = false;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    setTimeout(function () {
	      _this.showLogo = true;
	    }, 1 * 1000);
	
	    setTimeout(function () {
	      _this.$router.push({ path: '/hashtag' });
	    }, 4 * 1000);
	  }
	};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Renderer = __webpack_require__(173);
	
	var _Renderer2 = _interopRequireDefault(_Renderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Home',
	  components: {
	    Renderer: _Renderer2.default
	  },
	  mounted: function mounted() {
	    TweenMax.fromTo('.timeline', 0.5, { opacity: 0 }, { opacity: 1 }).delay(1.5);
	  }
	};

/***/ },
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 130 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 131 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 132 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 133 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 134 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 135 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ function(module, exports) {

	module.exports = {
		"API": {
			"url": "http://localhost",
			"port": 3000
		},
		"client": {
			"url": "http://localhost",
			"port": 4000
		},
		"app": {
			"tweet": {
				"numberPerRequest": 60
			},
			"lang": "en"
		},
		"production": {
			"API_URL": "https://tweetscape.herokuapp.com"
		}
	};

/***/ },
/* 156 */,
/* 157 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 158 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 159 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 160 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 161 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 162 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 163 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 164 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 165 */,
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(129)
	
	/* script */
	__vue_exports__ = __webpack_require__(71)
	
	/* template */
	var __vue_template__ = __webpack_require__(178)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(72)
	
	/* template */
	var __vue_template__ = __webpack_require__(183)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(73)
	
	/* template */
	var __vue_template__ = __webpack_require__(190)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(74)
	
	/* template */
	var __vue_template__ = __webpack_require__(189)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(75)
	
	/* template */
	var __vue_template__ = __webpack_require__(187)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(77)
	
	/* template */
	var __vue_template__ = __webpack_require__(185)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(130)
	
	/* script */
	__vue_exports__ = __webpack_require__(78)
	
	/* template */
	var __vue_template__ = __webpack_require__(179)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-187cc40f"
	
	module.exports = __vue_exports__


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(133)
	
	/* script */
	__vue_exports__ = __webpack_require__(79)
	
	/* template */
	var __vue_template__ = __webpack_require__(182)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5f6b35ba"
	
	module.exports = __vue_exports__


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(80)
	
	/* template */
	var __vue_template__ = __webpack_require__(184)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(135)
	
	/* script */
	__vue_exports__ = __webpack_require__(81)
	
	/* template */
	var __vue_template__ = __webpack_require__(188)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-da0787ee"
	
	module.exports = __vue_exports__


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(134)
	
	/* script */
	__vue_exports__ = __webpack_require__(82)
	
	/* template */
	var __vue_template__ = __webpack_require__(186)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-cde0931c"
	
	module.exports = __vue_exports__


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(132)
	
	/* script */
	__vue_exports__ = __webpack_require__(83)
	
	/* template */
	var __vue_template__ = __webpack_require__(181)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5f014158"
	
	module.exports = __vue_exports__


/***/ },
/* 178 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('gradient-canvas', {
	    style: (_vm.currentRoute != 'home' ? 'opacity: 1;' : 'opacity: 0;'),
	    attrs: {
	      "name": "canvas-interactive",
	      "default-state": "home-state"
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [_c('router-view')], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.showPreloaderIcon ? 'preloader show' : 'preloader',
	    style: (_vm.display ? 'display: table' : 'display: none')
	  }, [_c('div', {
	    staticClass: "preloader-center"
	  }, [_c('div', {
	    staticClass: "preloader-icon"
	  }, [_c('svg', {
	    attrs: {
	      "width": "34",
	      "height": "38",
	      "viewBox": "0 0 34 38"
	    }
	  }, [_c('path', {
	    staticClass: "preloader-path",
	    attrs: {
	      "stroke-dashoffset": "0",
	      "d": "M29.437 8.114L19.35 2.132c-1.473-.86-3.207-.86-4.68 0L4.153 8.114C2.68 8.974 1.5 10.56 1.5 12.28v11.964c0 1.718 1.22 3.306 2.69 4.165l10.404 5.98c1.47.86 3.362.86 4.834 0l9.97-5.98c1.472-.86 2.102-2.45 2.102-4.168V12.28c0-1.72-.59-3.306-2.063-4.166z"
	    }
	  }, [_c('animate', {
	    attrs: {
	      "attributeType": "XML",
	      "attributeName": "stroke-dashoffset",
	      "from": "0",
	      "to": "102px",
	      "dur": "1s",
	      "repeatCount": "indefinite"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    class: _vm.showPreloaderInfos ? 'informations show' : 'informations'
	  }, [(_vm.mobile) ? _c('div', {
	    staticClass: "mobile-infos"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _c('div', {
	    staticClass: "desktop-infos"
	  }, [_c('div', {
	    staticClass: "info move col"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(158)
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Move mouse to rotate camera")])]), _vm._v(" "), _c('div', {
	    staticClass: "info spacebar col"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(160)
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Press spacebar to slow down")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info landscape col"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(159)
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Turn your mobile to landscape mode")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info touch col"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(161)
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Touch the screen to slow down")])])
	}]}

/***/ },
/* 180 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('canvas', {
	    staticClass: "canvas-interactive",
	    attrs: {
	      "id": _vm.name,
	      "width": "512",
	      "height": "512"
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 181 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "timeline"
	  }, [_c('renderer')], 1)
	},staticRenderFns: []}

/***/ },
/* 182 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.sceneIsReady ? 'show' : 'hide',
	    attrs: {
	      "id": "renderer"
	    }
	  }, [_c('a-scene', {
	    attrs: {
	      "antialias": "true"
	    }
	  }, [_c('assets'), _vm._v(" "), _vm._l((_vm.visibleTweets), function(tweet) {
	    return _c('tweet', {
	      key: tweet.id,
	      attrs: {
	        "position": tweet.position,
	        "tweet": tweet
	      }
	    })
	  }), _vm._v(" "), _vm._l((_vm.visibleFrames), function(frame) {
	    return _c('frame', {
	      key: frame.id,
	      attrs: {
	        "id": frame.id,
	        "position": frame.position,
	        "rotation": frame.rotation
	      }
	    })
	  }), _vm._v(" "), _c('camera', {
	    attrs: {
	      "position": _vm.camera.position,
	      "controls-enabled": _vm.controlsEnabled
	    }
	  }), _vm._v(" "), _c('light', {
	    attrs: {
	      "position": _vm.camera.position
	    }
	  }), _vm._v(" "), _c('a-gradient-sky', {
	    attrs: {
	      "material": "shader: gradient; topColor: 2 25 65; bottomColor: 2 20 50;"
	    }
	  })], 2)], 1)
	},staticRenderFns: []}

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a-assets', [_c('img', {
	    attrs: {
	      "id": "logo-end-message",
	      "src": __webpack_require__(162)
	    }
	  }), _vm._v(" "), _c('a-asset-item', {
	    attrs: {
	      "id": "frame-obj",
	      "src": "static/models/frame.obj"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 184 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a-plane', {
	    attrs: {
	      "width": _vm.tweetParams.width,
	      "height": _vm.tweetParams.height,
	      "position": _vm.attributify(_vm.position),
	      "material": "opacity: 0;",
	      "look-at": "#camera"
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 185 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a-entity', [_c('a-entity', {
	    attrs: {
	      "light": "type: ambient; color: #6B4BBA; intensity: 0.5;"
	    }
	  }), _vm._v(" "), _c('a-entity', {
	    attrs: {
	      "id": "spot-light",
	      "light": "type: spot; angle: 45; color: #21C2CC; penumbra: 1; distance: 17; intensity: 0.7; decay: -3;",
	      "position": _vm.attributify(_vm.position)
	    }
	  }, [_c('a-animation', {
	    attrs: {
	      "attribute": "light.intensity",
	      "begin": "turn-the-light-off",
	      "to": "0"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "view-home"
	  }, [_c('div', {
	    class: _vm.showLogo ? '' : 'hide',
	    attrs: {
	      "id": "gradient-logo"
	    }
	  }, [_c('gradient-canvas', {
	    attrs: {
	      "name": "canvas-interactive-logo",
	      "default-state": "home-state"
	    }
	  }), _vm._v(" "), _vm._m(0)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mask"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(164)
	    }
	  })])
	}]}

/***/ },
/* 187 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a-entity', {
	    attrs: {
	      "position": _vm.attributify(_vm.position)
	    }
	  }, [_c('a-entity', {
	    attrs: {
	      "obj-model": "obj: #frame-obj;",
	      "scale": "2 2 2",
	      "position": "0 6 0",
	      "rotation": _vm.attributify(_vm.rotation),
	      "material": "shader: standard; color: #60ffec; side: double;"
	    }
	  }), _vm._v(" "), _c('a-entity', {
	    attrs: {
	      "obj-model": "obj: #frame-obj;",
	      "scale": "2 2 2",
	      "position": "0 -6 0",
	      "rotation": _vm.attributify(_vm.rotation),
	      "material": "shader: standard; color: #60ffec; side: double;"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "view-hashtag"
	  }, [_c('div', {
	    class: _vm.waitingResponseFromAPI ? 'content waiting' : 'content'
	  }, [_vm._m(0), _vm._v(" "), _c('h1', {
	    staticClass: "title"
	  }, [_vm._v("Insert your hashtag")]), _vm._v(" "), _c('div', {
	    staticClass: "select-your-hashtag"
	  }, [_c('div', {
	    staticClass: "search-hashtag"
	  }, [_c('p', {
	    staticClass: "hashtag-input"
	  }, [_c('span', {
	    on: {
	      "click": _vm.focusToInput
	    }
	  }, [_vm._v("#")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userHashtag),
	      expression: "userHashtag"
	    }],
	    style: (_vm.inputWidthStyle),
	    attrs: {
	      "type": "text",
	      "id": "hashtaginput",
	      "name": "hashtag",
	      "tabindex": "-1",
	      "maxlength": _vm.inputMaxLength,
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.userHashtag)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.userHashtag = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('button', {
	    attrs: {
	      "id": "start",
	      "disabled": !_vm.isHashtag
	    },
	    on: {
	      "click": _vm.start
	    }
	  }, [_vm._v("Let's start!")])])]), _vm._v(" "), _c('div', {
	    class: _vm.requestError.show ? 'request-error show' : 'request-error'
	  }, [_c('p', [_vm._v(_vm._s(_vm.requestError.message))])]), _vm._v(" "), _c('preloader', {
	    attrs: {
	      "display": _vm.isLoading
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "logo"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(163)
	    }
	  })])
	}]}

/***/ },
/* 189 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showEndMessage) ? _c('a-entity', {
	    attrs: {
	      "position": "0 0 -2"
	    }
	  }, [_c('a-entity', {
	    attrs: {
	      "id": "end-message-logo",
	      "geometry": "primitive: plane; height: 1; width: 1;",
	      "material": "shader: flat; flatShading: true; opacity: 0; src: #logo-end-message; transparent: true;",
	      "position": "0 0.5 0"
	    }
	  }, [_c('a-animation', {
	    attrs: {
	      "attribute": "material.opacity",
	      "delay": "1000",
	      "to": "1"
	    }
	  })], 1), _vm._v(" "), _c('a-entity', {
	    attrs: {
	      "id": "end-message-text",
	      "scale": "3 3 3",
	      "text": 'opacity: 0; align: center; value:' + _vm.message + ';',
	      "position": "0 -0.5 0"
	    }
	  }, [_c('a-animation', {
	    attrs: {
	      "attribute": "text.opacity",
	      "delay": "2000",
	      "to": "1"
	    }
	  })], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 190 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a-entity', {
	    attrs: {
	      "id": "camera",
	      "camera": "",
	      "position": _vm.attributify(_vm.position),
	      "look-controls": _vm.controlsEnabled ? '' : 'enabled: false; hmdEnabled: false;'
	    }
	  }, [_c('end-message')], 1)
	},staticRenderFns: []}

/***/ },
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.9f191196ff393f64c8f7.js